import React from 'react';

const arrowHeadBottomIcon = () => (
  <svg viewBox="0 0 54.19 60" transform="rotate(90, 0, 0)">
    <polygon points="0,0 54.19,30 0,60 	"/>
  </svg>
)

export default arrowHeadBottomIcon;